import Typography, { TypographyProps } from "@mui/material/Typography";

import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";

import { InsuranceAdoptionStatus } from "@graphql/api";
import { mapResidentInsuranceAdoptionStatus } from "@redux/residents/utils";

interface Props {
  isLoading?: boolean;
  status?: InsuranceAdoptionStatus | null;
  component?: TypographyProps["component"];
}

export default function InsuranceAdoptionStatusText({
  component,
  isLoading,
  status,
}: Props) {
  const statusText = mapResidentInsuranceAdoptionStatus(status);

  return (
    <Typography sx={{ color: "secondary.main" }} component={component}>
      <LoadingOrValue
        loading={!status && isLoading}
        value={statusText}
        height={28}
        width={124}
      />
    </Typography>
  );
}
